import styled from 'styled-components';

export default styled.div`
  border-radius: 50%;
  ${({ checked, theme }) => `
    ${
      checked
        ? `
      background: ${theme.modalToggleCheckedBgColor};
      height: 20px;
      width: 20px;
    `
        : `
      background: ${theme.modalToggleBgColor};
      border: 2px solid ${theme.modalToggleBorderColor};
      height: 16px;
      width: 16px;
    `
    }
    > svg {
      fill: ${theme.modalToggleCheckedColor};
    }
  `}
`;
